import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiService } from "../../services/apiService";
import {
  setSessionUser,
  getQuotesCount,
  getQuotesIsEligible,
  setPocketOfficeIsEligible,
  setYellowConnectIsEligible,
  setLoading,
} from "../../redux/Actions";
import { makeCustomerNumber } from "../common/CustomerNumberUtils";

const InitWithApi = () => {
  const isPublicRoute = useSelector((state) => state.publicRoute.isPublicRoute);
  const dispatch = useDispatch();

  const setYellowConnectStatus = ({ services }) => {
    let status = false;
    if (services && services.length > 0) {
      const yellowConnectService = services.filter(
        (service) =>
          service.serviceType === "Yellow Connect" &&
          service.oktaUserProvisioningStatus === "COMPLETED"
      );
      if (yellowConnectService.length >= 1) {
        status = false;
      }
    }
    dispatch(setYellowConnectIsEligible({ status }));
  };

  const setPocketOfficeStatus = async ({ services }) => {
    let status = "disabled";

    if (services && services.length > 0) {
      const livePoServices = services.filter((service) => {
        return (
          service.serviceType === "Pocket Office" && service.status === "Live"
        );
      });

      if (livePoServices.length === 1) {
        status = "live";
      }
    }
    dispatch(setPocketOfficeIsEligible({ status }));
  };

  useEffect(() => {
    const loggedInuser = async () => {
      if (!isPublicRoute) {
        dispatch(setLoading({ isLoading: true }));
        const user = await apiService.get("/loggedinuser");
        if (user) {
          dispatch(setSessionUser(user.Data));
          const customerNumber = makeCustomerNumber(
            user.Data.contact.customerNumber,
            user.Data.contact.apfId
          );

          try {
            const quotes = await apiService.get(
              `/customer/${customerNumber}/quotes?detail=count`
            );
            if (quotes && quotes.Data) {
              dispatch(getQuotesCount(quotes.Data));
              dispatch(getQuotesIsEligible(quotes.Data));
            }
          } catch (err) {
            console.warn(
              "API Gateway error: unable to check Quotes eligibility"
            );
          }

          await setPocketOfficeStatus(user.Data);
          setYellowConnectStatus(user.Data);
        }
        dispatch(setLoading({ isLoading: false }));
      }
    };
    loggedInuser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default InitWithApi;
